import { ReactElement, ReactNode } from 'react';
import { ErrorBoundary as ErrorBoundaryComponent } from 'react-error-boundary';

interface Props {
  children?: ReactNode;
}

export const ErrorBoundary = ({ children }: Props): ReactElement => {
  return (
    <ErrorBoundaryComponent fallback={<div>Qui mettere un componente di fallback</div>}>
      {children}
    </ErrorBoundaryComponent>
  );
};
